document.addEventListener('DOMContentLoaded', function() {
  var sections = {
    'shopify-section-sections--19437681246458__mobile-menu': 'Mobile site navigation',
    'CustomCode--template--19437682426106__section_custom_code_WPWHcn': 'Main page content'
  };

  Object.keys(sections).forEach(function(sectionId) {
    var section = document.getElementById(sectionId);
    if (section) {
      section.setAttribute('aria-label', sections[sectionId]);
      section.setAttribute('role', 'region'); 
    }
  });
});
